import React, { useState } from "react";
import { FAQS } from "@/data/policies";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Search } from "lucide-react";

export default function FAQ() {
  const [q, setQ] = useState("");

  const filtered = FAQS.map((cat) => ({
    ...cat,
    items: cat.items.filter((it) => {
      if (!q.trim()) return true;
      const needle = q.toLowerCase();
      return it.q.toLowerCase().includes(needle) || it.a.toLowerCase().includes(needle);
    }),
  })).filter((c) => c.items.length);

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-12" data-testid="faq-page">
      <div className="mb-10 max-w-3xl">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">SUPPORT / FAQS</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tighter mt-2 text-black">FREQUENTLY<br />ASKED.</h1>
        <p className="text-black/60 mt-4">Most answers are here. Can&apos;t find what you need? <a href="/contact" className="underline text-black hover:text-[#FF3B30]">Contact us →</a></p>
      </div>

      <div className="relative max-w-xl mb-10">
        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-black/40" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search FAQs..."
          className="w-full pl-12 pr-4 py-4 bg-white border border-black/20 focus:border-black outline-none font-display tracking-widest text-sm"
          data-testid="faq-search"
        />
      </div>

      {filtered.length === 0 ? (
        <div className="border border-black/10 p-12 text-center">
          <div className="font-display text-2xl tracking-tighter">NO MATCHES</div>
          <p className="text-black/60 mt-2">Try different keywords or <a href="/contact" className="underline">contact our team</a>.</p>
        </div>
      ) : (
        <div className="space-y-10">
          {filtered.map((cat) => (
            <section key={cat.category}>
              <h2 className="font-display text-2xl tracking-tighter text-[#FF3B30] mb-4">{cat.category}</h2>
              <Accordion type="single" collapsible className="space-y-2">
                {cat.items.map((it) => (
                  <AccordionItem key={`${cat.category}-${it.q}`} value={`${cat.category}-${it.q}`} className="border border-black/10">
                    <AccordionTrigger className="px-4 py-4 font-display tracking-wide text-sm text-left text-black hover:no-underline hover:text-[#FF3B30]" data-testid={`faq-q-${cat.category}-${it.q.slice(0,30)}`}>
                      {it.q}
                    </AccordionTrigger>
                    <AccordionContent className="px-4 pb-4 text-black/75 leading-relaxed">
                      {it.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
